// extracted by mini-css-extract-plugin
module.exports = {"name":"columns_name__135bs"};